var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmergency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1046_87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9588 19.9333V19.9272C17.3274 19.7834 17.5706 19.4659 17.5706 18.8663C17.5706 18.0126 17.0154 17.6256 16.1666 17.6256C15.7607 17.6256 15.3933 17.6378 14.999 17.6817V21.8169H15.8046V20.1825H16.2226C16.3287 20.1825 16.3537 20.2386 16.3847 20.3568L16.7668 21.8163H17.6084L17.1026 20.1259C17.0776 20.0211 17.0465 19.9583 16.9588 19.9333ZM16.2537 19.5397H15.8046V18.2801C15.9362 18.2679 16.0666 18.2612 16.1971 18.2612C16.6785 18.2612 16.7778 18.5482 16.7778 18.9157C16.7778 19.3526 16.6224 19.5397 16.2537 19.5397Z",
    fill: "#F82D17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.502 19.996H23.5958V19.3281H22.502V18.3306H23.7147V17.6566H21.6982V21.8168H23.764V21.1611H22.502V19.996Z",
    fill: "#F82D17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.38995 19.996H7.48255V19.3281H6.38995V18.3306H7.60077V17.6566H5.58496V21.8168H7.65135V21.1611H6.39056L6.38995 19.996Z",
    fill: "#F82D17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0759 19.996H14.1697V19.3281H13.0759V18.3306H14.2879V17.6566H12.2715V21.8168H14.3373V21.1611H13.0759V19.996Z",
    fill: "#F82D17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88627 19.2343L9.06849 17.6566H8.31348V21.8168H9.10018V19.1289L9.88688 20.7065L10.6669 19.1228H10.6919V21.8168H11.4469V17.6566H10.6919L9.88627 19.2343Z",
    fill: "#F82D17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7062 20.1758H20.2729V20.3251C20.2729 20.7565 20.2107 21.2428 19.6745 21.2428C18.9755 21.2428 18.9573 20.2513 18.9573 19.7401C18.9573 19.2337 19.0078 18.2739 19.7001 18.2739C20.0243 18.2739 20.1803 18.4543 20.3607 18.6785L20.8043 18.0856C20.485 17.7688 20.1547 17.5865 19.7117 17.5865C18.5325 17.5865 18.1133 18.7096 18.1133 19.7443C18.1133 20.7681 18.4947 21.8845 19.6495 21.8845C20.7781 21.8845 21.0035 20.9046 21.0035 20.0003V19.5146H19.7056V20.1752L19.7062 20.1758Z",
    fill: "#F82D17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9547 21.8168H32.7542V20.2263L33.809 17.656H32.9906L32.3605 19.5518L31.7298 17.656H30.8682L31.9553 20.2696L31.9547 21.8168Z",
    fill: "#F82D17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4258 21.8168H25.2125V19.2477H25.2314L26.5671 21.8168H27.2722V17.6566H26.4922V20.1197H26.4806L25.2064 17.656H24.4264L24.4258 21.8168Z",
    fill: "#F82D17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9134 0.503296H5.0564C2.57868 0.503296 0.258789 2.82806 0.258789 5.30517V34.1542C0.258789 36.6325 2.58782 38.9689 5.06676 38.9689H33.9146C36.3923 38.9689 38.7256 36.6447 38.7256 34.167V5.30883C38.7256 2.83172 36.3923 0.503905 33.9134 0.503905V0.503296ZM34.8951 24.8685H24.6271V35.1262H14.3597V24.8685H4.08871V14.6036H14.3597V4.34601H24.6271V14.6036H34.8951V24.8685Z",
    fill: "#F82D17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5323 21.8851C30.0436 21.8857 30.4433 21.648 30.7187 21.311L30.3068 20.7242C30.1008 20.9984 29.915 21.2044 29.5762 21.2044C28.9272 21.2044 28.8138 20.3007 28.8138 19.7395C28.8138 18.9905 28.9887 18.2733 29.5579 18.2733C29.8644 18.2733 30.0332 18.4787 30.213 18.7541L30.6944 18.1856C30.3744 17.8059 30.0564 17.5865 29.5701 17.5865C28.4153 17.5865 27.9717 18.6718 27.9717 19.7395C27.9717 20.8686 28.3836 21.8851 29.5323 21.8851Z",
    fill: "#F82D17"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1046_87"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergency);
export default __webpack_public_path__ + "static/media/emergency.76a66995f3576ef5457b1f798da70d18.svg";
export { ForwardRef as ReactComponent };